import styled from "styled-components"

interface Props {
  brandColor: string,
  isMobile: boolean
}

export default styled.div<Props>`
  position: relative;
  z-index: 25;
  height: ${({isMobile}) => (isMobile ? 8 : 10)}px;
  background-color: ${({brandColor}) => (brandColor)};
  box-shadow: ${({theme}) => theme.shadows.inset.low};
`
